const DepartmentIcon = ({ size = 16, color = '#212529' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.16634 13.3333C6.16634 12.32 6.98634 11.5 7.99967 11.5C9.01301 11.5 9.83301 12.32 9.83301 13.3333C9.83301 14.3467 9.01301 15.1667 7.99967 15.1667C6.98634 15.1667 6.16634 14.3467 6.16634 13.3333ZM8.83301 13.3333C8.83301 12.8733 8.45967 12.5 7.99967 12.5C7.53967 12.5 7.16634 12.8733 7.16634 13.3333C7.16634 13.7933 7.53967 14.1667 7.99967 14.1667C8.45967 14.1667 8.83301 13.7933 8.83301 13.3333Z"
      fill={color}
    />
    <path
      d="M11.5003 13.3333C11.5003 12.32 12.3203 11.5 13.3337 11.5C14.347 11.5 15.167 12.32 15.167 13.3333C15.167 14.3467 14.347 15.1667 13.3337 15.1667C12.3203 15.1667 11.5003 14.3467 11.5003 13.3333ZM14.167 13.3333C14.167 12.8733 13.7937 12.5 13.3337 12.5C12.8737 12.5 12.5003 12.8733 12.5003 13.3333C12.5003 13.7933 12.8737 14.1667 13.3337 14.1667C13.7937 14.1667 14.167 13.7933 14.167 13.3333Z"
      fill={color}
    />
    <path
      d="M0.833333 13.3333C0.833333 12.32 1.65333 11.5 2.66667 11.5C3.68 11.5 4.5 12.32 4.5 13.3333C4.5 14.3467 3.68 15.1667 2.66667 15.1667C1.65333 15.1667 0.833333 14.3467 0.833333 13.3333ZM3.5 13.3333C3.5 12.8733 3.12667 12.5 2.66667 12.5C2.20667 12.5 1.83333 12.8733 1.83333 13.3333C1.83333 13.7933 2.20667 14.1667 2.66667 14.1667C3.12667 14.1667 3.5 13.7933 3.5 13.3333Z"
      fill={color}
    />
    <path
      d="M6.16634 2.66732C6.16634 1.65398 6.98634 0.833984 7.99967 0.833984C9.01301 0.833984 9.83301 1.65398 9.83301 2.66732C9.83301 3.68065 9.01301 4.50065 7.99967 4.50065C6.98634 4.50065 6.16634 3.68065 6.16634 2.66732ZM8.83301 2.66732C8.83301 2.20732 8.45967 1.83398 7.99967 1.83398C7.53967 1.83398 7.16634 2.20732 7.16634 2.66732C7.16634 3.12732 7.53967 3.50065 7.99967 3.50065C8.45967 3.50065 8.83301 3.12732 8.83301 2.66732Z"
      fill={color}
    />
    <path
      d="M7.5 12V4C7.5 3.72667 7.72667 3.5 8 3.5C8.27333 3.5 8.5 3.72667 8.5 4V12C8.5 12.2733 8.27333 12.5 8 12.5C7.72667 12.5 7.5 12.2733 7.5 12Z"
      fill={color}
    />
    <path
      d="M2.16634 12.0007V9.33398C2.16634 7.72065 3.05301 6.83398 4.66634 6.83398L11.333 6.83398C12.9463 6.83398 13.833 7.72065 13.833 9.33398V12.0007C13.833 12.274 13.6063 12.5007 13.333 12.5007C13.0597 12.5007 12.833 12.274 12.833 12.0007V9.33398C12.833 8.28065 12.3863 7.83398 11.333 7.83398L4.66634 7.83398C3.61301 7.83398 3.16634 8.28065 3.16634 9.33398V12.0007C3.16634 12.274 2.93967 12.5007 2.66634 12.5007C2.39301 12.5007 2.16634 12.274 2.16634 12.0007Z"
      fill={color}
    />
  </svg>
);

export default DepartmentIcon;
